import { render, staticRenderFns } from "./ViewWarehouseComponent.vue?vue&type=template&id=9f98e8d6&"
import script from "./ViewWarehouseComponent.vue?vue&type=script&lang=js&"
export * from "./ViewWarehouseComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports